












































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IDomainsProvider,
  IDomainsProviderMethods
} from "@/models/providers/domains";

@Component({
  components: {
    "domains-grid-item": () =>
      import("@/components/app/admin/domains/domainsGridItem.vue")
  }
})
export default class DomainsGrid extends Vue {
  // Inject

  @Inject({ from: "domainsProvider" })
  public domainsProvider!: () => IDomainsProvider;

  @Inject({ from: "domainsProviderMethods" })
  public $domainsMethods!: IDomainsProviderMethods;

  // Computed

  public get $domainsData() {
    return this.domainsProvider();
  }

  public get skeletonSize() {
    const { loading, total } = this.$domainsData.table;
    const size = total || (this.$store.getters["ui/isMobile"] ? 2 : 6);
    if (loading || !total) return size;
    return 0;
  }
}
